export default __webpack_public_path__ + "static/Screen Shot 2022-05-31 at 15.10.42-84d8196596adba1c2f44735539e4e022.png";